<template>
  <div class="course-details">
    <v-overlay :value="loadingCurrentCourse" z-index="4">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <course-details-tabs :disable-steps="true">
      <template v-slot:settings>
        <course-form
          :key="`course-form-${renderId}`"
          hideNonEditable
          @submit="submitForm"
        />
      </template>
      <template v-slot:steps>steps</template>
    </course-details-tabs>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import CourseDetailsTabs from '@/components/courses/CourseDetailsTabs.vue'
import CourseForm from '@/components/courses/CourseForm.vue'
export default {
  name: 'CourseDetails',
  components: {
    CourseDetailsTabs,
    CourseForm,
  },
  mixins: [],
  props: {},
  data() {
    return {
      renderId: 0,
    }
  },
  computed: {
    ...mapGetters('dictionariesStates', ['getMimeTypes']),
    ...mapState('dictionariesStates', [
      'dictionariesLoaded',
      'dictionaryPracticeUserRole',
      'dictionaryBhUsersRoleIds',
      'dictionaryFeatureFlagState',
    ]),
    ...mapState('coursesStates', ['loadingCurrentCourse']),
    ...mapGetters('userStates', ['getRolename', 'getToken']),
    isCompanyUser() {
      // is Company Admin, Company Advisor or Company Team
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Advisor ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Administrator ||
        this.dictionaryPracticeUserRole[this.getRolename] ===
          this.dictionaryPracticeUserRole.Team
      )
    },
    isAdvisor() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Advisor
      )
    },
  },
  mounted() {
    this.renderId = this.renderId + 1
  },
  methods: {
    ...mapMutations('appStates', ['setSnackbarNotification']),
    ...mapActions('coursesStates', ['createCourseDefinition']),
    async submitForm(data) {
      if (data.description.length > 30000) {
        this.setSnackbarNotification('Description is too long')
        return
      }
      const { successMessage, ...rest } = data
      const course = await this.createCourseDefinition(rest)

      if (course?.id) {
        this.$router.push({
          name: 'Course Details',
          path: '/courses/:id',
          params: { id: course.id },
        })
      }
    },
  },
  watch: {
    $route(to, from) {
      if (from?.name === 'Create Course' || to?.name === 'Create Course') {
        this.renderId = this.renderId + 1
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.course-details {
  padding: (2 * $gutter) (2 * $gutter) (2.5 * $gutter);
  height: 100%;
}
</style>
